import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddDept = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/dept`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onAddDeptUser = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/dept/user`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };



  const onGetOrgDept = async ( id:any ,config: any) => {
    try {

      const response = await axios.get(`${baseURL}/dept/organization/${id}`,config);
      return response.data;

    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  const onGetDeptUsers = async ( id:any ,config: any) => {
    try {

      const response = await axios.get(`${baseURL}/dept/users/${id}`,config);
      return response.data;

    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


  export{onAddDept,onGetDeptUsers,onAddDeptUser, onGetOrgDept}